import { useEffect } from "react";
import { Link, Outlet } from "react-router-dom";
import { Map, PlacesLayer } from "~/components/map";
import { usePlaces } from "~/lib/placesStore";
import { DEFAULT_MAP_CENTER } from "~/lib/mapConstants";
import { routes } from "~/lib/routes";
import { UserMenu } from "~/components/UserMenu";
import nomaIcon from "~/assets/noma-icon.svg";

/**
 * Layout for the Adventure Map Builder (/maps/*).
 * Provides a persistent map instance and layout regions for child routes.
 */
export default function BuilderLayout() {
  const { places, load } = usePlaces();

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Map.Canvas center={DEFAULT_MAP_CENTER} zoom={4}>
      <PlacesLayer places={places} />

      <Map.HeaderLeft>
        <Link
          to={routes.to.home()}
          title="Go to home"
          className="shrink-0 size-11 focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none"
        >
          <img src={nomaIcon} alt="NOMA.TO" className="size-full" />
        </Link>
      </Map.HeaderLeft>

      <Map.HeaderRight>
        <UserMenu />
      </Map.HeaderRight>

      <Outlet />
    </Map.Canvas>
  );
}
